import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AgGridI, AgGridPaginationConfig, TablePaginationModel } from 'src/app/shared/components/ag-grid/ag-grid.model';
import { AgGridDataModelListManager } from './list-manager.model';
import { GridName, StorageName } from 'src/app/shared/model/ag-grid-common-constant.model';
import { AgGridComponent } from 'src/app/shared/components/ag-grid/ag-grid.component';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ListManagerService } from './list-manager.service';
import { Router } from '@angular/router';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { AgGridService } from 'src/app/shared/components/ag-grid/ag-grid.service';
import { Menu } from 'src/app/shared/services/nav.service';

@Component({
  selector: 'app-list-manager',
  templateUrl: './list-manager.component.html',
  styleUrls: ['./list-manager.component.scss']
})
export class ListManagerComponent implements OnInit  {
  agGridDataModelListManager: AgGridI;
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>
  tablePaginationModel = new TablePaginationModel();
  gridApiForManagerList : any;
  storageName = StorageName;
  totalRecords : number;
  agGridPaginationConfig = new AgGridPaginationConfig();

  constructor(public listManagerService :ListManagerService,public agGridService: AgGridService,
    public storageService: StorageService,private tabsService: TabsService, private router: Router,
) { }

  ngOnInit(): void {
    this.agGridDataModelListManager = AgGridDataModelListManager;

  }
  onGridReady(event) {
    this.gridApiForManagerList = event;
    this.tablePaginationModel = this.storageService.retrieve(GridName.AG_GRID_PAGINATIONMODEL)
    if(this.tablePaginationModel)
      this.getAllManagerList()
  }

  onPagination(pagination: TablePaginationModel) {
    this.storeChangedPagination(pagination)
    this.getAllManagerList()
  }
  storeChangedPagination(paginationModel: TablePaginationModel){
    this.tablePaginationModel = paginationModel
  }

  getAllManagerList(){
    if (this.grids?.first){ 
      this.grids.first.agGridPaginationConfig.rows = []
      this.grids.first.isLoading = true;
        this.listManagerService.getAllManagerList(this.tablePaginationModel).subscribe({
         next : (res) =>{
           if(res?.isSuccess) {
             this.grids.first.isLoading = false;
             this.totalRecords = res.totalRecords;
             if(res?.response == null){
               this.grids.first.agGridPaginationConfig.rows = []
               this.gridApiForManagerList?.api?.setRowData([]);
             }else{
               this.gridApiForManagerList?.api?.setRowData(res?.response);
             }
             let list = res.response;
             this.storageService.store(StorageName.LISTMANAGER_GRID, list);
            this.grids.first.updateServersidePaginationData(this.tablePaginationModel,this.totalRecords);
            this.listManagerService.selectionChanged.next(this.gridApiForManagerList)
           } else {
             this.grids.first.isLoading = false;
             this.grids.first.agGridPaginationConfig.rows = []
             this.gridApiForManagerList?.api?.setRowData([]);
           }
         },
         error : (err) => {
           this.grids.first.isLoading = false;
           this.grids.first.agGridPaginationConfig.rows = []
           this.gridApiForManagerList?.api?.setRowData([]);
         }
        })
     }
  }
  onTextCellClick(params){
    this.changeRoute(params)
  }
  changeRoute(params) {
    if(params.data.noOfRecords > 0){
    this.listManagerService.id=params.data.id;
    let id = params.value
    let url = `list-manager/list-manager-info/${this.listManagerService.id}`
    const item: Menu = { path: url, icon: '', title: params.value, type: 'link',id:params.data.id}
    this.tabsService.addTab(item);
    this.router.navigateByUrl(url);
    this.initDatatable()
    }
  }
  initDatatable() {
    this.tablePaginationModel={
      sortColumn: "",
      sortDirection: "",
      pageNumber: this.agGridPaginationConfig.currentPageNumber,
      pageSize: this.agGridPaginationConfig.pageSize,
      searchText: this.agGridPaginationConfig.searchText,
      getAll: this.agGridPaginationConfig.pageSize == 1 ? true : false,
      id:this.listManagerService.id,
  }
    this.agGridService.tablePaginationData.next(this.tablePaginationModel);
  }
}
